(() => {
  if (!window.theme || !theme.CartForm || theme.CartForm.prototype.lrDrawerInstalled) return;
  const proto = theme.CartForm.prototype;
  proto.lrDrawerInstalled = true;
  const nativeBuild = proto.buildCart;
  const nativeMarkup = proto.cartMarkup;
  const nativeParse = proto._parseProductHTML;
  const fallback = () => document.getElementById('CartDrawerForm')?.dataset.lrErrorMessage || '';
  const isDrawer = form => form.location === 'cart-drawer';
  const error = (form, message) => {
    const node = form.form.querySelector('[data-lr-error]');
    if (node) { node.textContent = message || ''; node.hidden = !message; }
  };
  const busy = (form, value) => {
    form.form.setAttribute('aria-busy', String(value));
    form.form.querySelectorAll('[data-lr-adjust], [data-lr-quantity], [data-lr-remove], .cart__checkout').forEach(node => { node.disabled = value; });
  };
  const reservationKey = 'laerke-cart-reservation-deadline';
  let reservationDeadline = 0;
  try { reservationDeadline = Number(sessionStorage.getItem(reservationKey)) || 0; } catch (_) {}
  const updateReservationTimer = () => {
    const drawer = document.getElementById('CartDrawer');
    const notice = drawer?.querySelector('[data-lr-reservation]');
    const timer = notice?.querySelector('[data-lr-timer]');
    const label = notice?.querySelector('[data-lr-timer-label]');
    const items = drawer?.querySelector('[data-products] .cart__items');
    if (!timer || !label || !items) return;
    const count = Number(items.dataset.count);
    if (!count) {
      reservationDeadline = 0;
      try { sessionStorage.removeItem(reservationKey); } catch (_) {}
      timer.textContent = '10:00';
      label.textContent = notice.dataset.activeLabel;
      return;
    }
    if (!reservationDeadline) {
      reservationDeadline = Date.now() + 10 * 60 * 1000;
      try { sessionStorage.setItem(reservationKey, String(reservationDeadline)); } catch (_) {}
    }
    const remaining = Math.max(0, Math.ceil((reservationDeadline - Date.now()) / 1000));
    timer.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
    label.textContent = remaining > 0 ? notice.dataset.activeLabel : notice.dataset.expiredLabel;
  };
  const synchronize = form => {
    const items = form.form.querySelector('[data-products] .cart__items');
    if (!items) return;
    const money = amount => theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    form.form.querySelectorAll('[data-lr-count]').forEach(node => { node.textContent = items.dataset.count; });
    form.form.querySelectorAll('[data-lr-total]').forEach(node => { node.innerHTML = money(items.dataset.cartSubtotal); });
    form.form.querySelectorAll('[data-lr-original-total]').forEach(node => { node.innerHTML = money(items.dataset.cartOriginalSubtotal); });
    updateReservationTimer();
  };
  proto._parseProductHTML = function(text) {
    if (isDrawer(this) && !text.includes('data-lr-cart-markup')) {
      text = this.lrLatestMarkup || this.products.innerHTML + this.discounts.innerHTML;
    }
    return nativeParse.call(this, text);
  };
  proto.cartMarkup = function(text) {
    nativeMarkup.call(this, text);
    if (isDrawer(this)) synchronize(this);
  };
  proto.buildCart = function() {
    if (!isDrawer(this)) return nativeBuild.call(this);
    bindDrawer(this);
    const version = this.lrBuildVersion = (this.lrBuildVersion || 0) + 1;
    busy(this, true);
    const url = new URL(theme.routes.cartPage, window.location.origin);
    url.searchParams.set('view', 'lr-drawer');
    url.searchParams.set('t', Date.now());
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(response => { if (!response.ok) throw new Error(fallback()); return response.text(); })
      .then(text => {
        if (version !== this.lrBuildVersion) return false;
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        if (!parsed.querySelector('.cart__items') || !parsed.querySelector('.cart__discounts')) throw new Error(fallback());
        this.lrLatestMarkup = text;
        this.cartMarkup(text);
        error(this, '');
        return true;
      })
      .catch(reason => { error(this, reason.message || fallback()); return false; })
      .finally(() => { if (version === this.lrBuildVersion) busy(this, !!this.lrChanging); });
  };
  const change = async (form, input, quantity) => {
    if (form.lrChanging || !input || !Number.isInteger(quantity) || quantity < 0) return;
    clearTimeout(form.lrInputTimer);
    form.lrChanging = true;
    busy(form, true);
    error(form, '');
    try {
      const response = await theme.cart.changeItem(input.dataset.key, quantity);
      const cart = typeof response === 'string' ? JSON.parse(response) : response;
      if (cart.status >= 400) throw new Error(cart.description || cart.message || fallback());
      await form.buildCart();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (reason) {
      error(form, reason.message || fallback());
    } finally {
      form.lrChanging = false;
      busy(form, false);
    }
  };
  function bindDrawer(form) {
    if (form.form.dataset.lrBound) return;
    form.form.dataset.lrBound = 'true';
    form.form.addEventListener('click', event => {
      const button = event.target.closest('[data-lr-adjust], [data-lr-remove]');
      if (!button) return;
      event.preventDefault();
      const input = button.closest('.lr-cart-item').querySelector('[data-lr-quantity]');
      const quantity = button.hasAttribute('data-lr-remove') ? 0 : Math.max(0, Number(input.value) + Number(button.dataset.lrAdjust));
      change(form, input, quantity);
    });
    form.form.addEventListener('input', event => {
      if (!event.target.matches('[data-lr-quantity]')) return;
      clearTimeout(form.lrInputTimer);
      const input = event.target;
      if (input.value !== '') form.lrInputTimer = setTimeout(() => change(form, input, Number(input.value)), 400);
    });
    form.form.addEventListener('change', event => {
      if (event.target.matches('[data-lr-quantity]')) change(form, event.target, Number(event.target.value));
    });
  }
  document.addEventListener('drawerOpen.CartDrawer', () => {
    if (reservationDeadline <= Date.now()) reservationDeadline = 0;
    updateReservationTimer();
  });
  updateReservationTimer();
  window.setInterval(updateReservationTimer, 1000);
  document.dispatchEvent(new CustomEvent('cart:build'));
})();

